export enum BuilderArea {
  layout = 'layout',
  settings = 'settings',
  preview = 'dashboardPreview',
}